'use es6';

import keyMirror from 'react-utils/keyMirror';
export default keyMirror({
  UNINITIALIZED: null,
  PENDING: null,
  SUCCEEDED: null,
  FAILED: null
});